import { Component, Input } from '@angular/core';

@Component({
    standalone: false,
    selector: 'app-sgp-timeline-item',
    template: ''
})
export class TimelineItemComponent {

    @Input() title: string;
    @Input() label: string;
    @Input() subLabel: string;

    /**
     * If isActive is false, timeline becomes disabled
     */
    @Input()
    isActive: boolean = true;

    /**
     * If isChecked is true it means that circle box is checked
     */
    @Input()
    isChecked: boolean = false;

    /**
     * If label is a link,then this is the refernece of that link
     */
    @Input()
    labelLinkRef: string = null;

    /**
     * If label is a routerLink,then this is the refernece of that route
     */
    @Input()
    labelRouteRef: string = null;

    /**
     * If label is a modal, then this is the modalId to be opened
     */
    @Input()
    labelModalId: string = null;

    constructor() {
    }
}
